import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserErrorComponent } from './user-error/user-error.component';
import { ErrorModule } from 'src/app/shared/components/error/error.module';
import { GeneralErrorComponent } from './general-error/general-error.component';
import { ErrorsRoutingModule } from './errors-routing.module';
import { PseErrorComponent } from './pse-error/pse-error.component';
import { OtpErrorComponent } from './otp-error/otp-error.component';
import { PsePendingErrorComponent } from './pse-pending-error/pse-pending-error.component';
import { ReadSummaryErrorComponent } from './read-summary-error/read-summary-error.component';
import { ReadSummaryPseErrorComponent } from './read-summary-pse-error/read-summary-pse-error.component';
import { TimeErrorComponent } from './time-error/time-error.component';
import { NoIdentityErrorComponent } from './biometrics/no-identity-error/no-identity.component';
import { TechFailedComponent } from './biometrics/tech-failed/tech-failed.component';
import { CameraErrorComponent } from './biometrics/camera-error/camera-error.component';
import { NoAccountsErrorComponent } from './no-accounts-error/no-accounts-error.component';

@NgModule({
  declarations: [
    UserErrorComponent,
    GeneralErrorComponent,
    PseErrorComponent,
    OtpErrorComponent,
    PsePendingErrorComponent,
    ReadSummaryErrorComponent,
    ReadSummaryPseErrorComponent,
    TimeErrorComponent,
    NoIdentityErrorComponent,
    TechFailedComponent,
    CameraErrorComponent,
    NoAccountsErrorComponent
  ],
  imports: [CommonModule, ErrorsRoutingModule, ErrorModule]
})
export class ErrorsModule {}
